import {
  Box,
  Typography,
  IconButton,
  Stack,
} from "@mui/material";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { useSelector } from "react-redux";
import { RootState } from "../../../store/types/rootState";
import { getThemeByAccountId, getPrimaryColorByAccountId } from "../../../utils/styleConstants";

interface DesktopTicketsProps {
  ticketQuantity: number | null;
  sumTicketQuantity: (ticket: number) => void;
  handleChangeQuantity: (event: React.ChangeEvent<HTMLInputElement>) => void;
  additions: Array<number>;
}

export const MobileTicketsV3: React.FC<DesktopTicketsProps> = ({
  ticketQuantity,
  sumTicketQuantity,
}) => {
  const accountId = useSelector(({ account }: RootState) => account.id);
  const primaryColor = getPrimaryColorByAccountId(accountId);

  return (
    <Box width="100%" mt={3} display="flex" flexDirection="column" alignItems="center">
      <Stack direction="row" alignItems="center" spacing={4}>
        {/* Botón - */}
        <IconButton
          onClick={() => sumTicketQuantity(-1)}
          sx={{
            backgroundColor: primaryColor,
            color: "white",
            width: 60,
            height: 60,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
            '&:hover': {
              backgroundColor: primaryColor,
              opacity: 0.85,
            },
          }}
        >
          <RemoveIcon fontSize="large" />
        </IconButton>

        {/* Número de boletos */}
        <Box textAlign="center">
          <Typography variant="h4" fontWeight="bold">
            {ticketQuantity ?? 0}
          </Typography>
          <Typography variant="subtitle2" fontWeight="medium">
            TICKETS
          </Typography>
        </Box>

        {/* Botón + */}
        <IconButton
          onClick={() => sumTicketQuantity(1)}
          sx={{
            backgroundColor: primaryColor,
            color: "white",
            width: 60,
            height: 60,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
            '&:hover': {
              backgroundColor: primaryColor,
              opacity: 0.85,
            },
          }}
        >
          <AddIcon fontSize="large" />
        </IconButton>
      </Stack>
    </Box>
  );
};
